import { CaptureIcon } from "@/components/ui/icons";
import { ArrowLeft } from "lucide-react";
import React from "react";

type Props = {
	children: React.ReactNode;
	onBackClick: () => void;
	onCaptureClick: () => void;
	isLoading: boolean;
};

export function CameraOverlay(props: Props) {
	const { children, onBackClick, onCaptureClick, isLoading } = props;
	return (
		<div className="relative w-full h-dvh bg-black overflow-hidden">
			{/* Live camera */}
			{children}
			{/* Top bar */}

			<div className="absolute  z-50 top-0 left-0 right-0 bottom-0">
				<div className="absolute left-4 top-4 z-50">
					<button type="button" onClick={onBackClick}>
						<ArrowLeft className="text-white w-5 h-5 lg:w-8 lg:h-8" />
					</button>
				</div>
				<div className="flex items-center py-4 justify-between flex-col  h-full w-full">
					<div className="flex items-center justify-center gap-2 top-4 relative z-50">
						<h2 className="text-white font-bold text-2xl lg:text-3xl">
							Selfie
						</h2>
						<div className="w-5 h-5 lg:w-8 lg:h-8 bg-white text-black font-bold text-xs lg:text-sm flex items-center justify-center rounded-sm">
							i
						</div>
					</div>

					{/* Oval face mask */}
					<div className="mask-oval-blur-shadow relative max-w-[95vw] z-40 h-full aspect-[3/4] my-14 lg:my-10 rounded-full" />
					{/* Instruction text */}
					<div className="text-center relative z-50">
						<h3 className="text-white font-bold text-2xl">Center your face</h3>
						<p className="text-white/80 font-normal text-base mt-1 px-4">
							Align your face to the center and take a photo.
						</p>
						<div className="w-full flex justify-center z-10 mt-4">
							<button
								disabled={isLoading}
								type="button"
								onClick={onCaptureClick}
								className="w-16 h-16 rounded-full bg-white flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
							>
								{isLoading ? (
									<div className="w-6 h-6 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
								) : (
									<CaptureIcon className="w-6 h-6" />
								)}
							</button>
						</div>
					</div>

					{/* Capture button */}
				</div>
			</div>
		</div>
	);
}
